import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-glow"></div>
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="logo-text">EURO<span className="logo-accent">JDM</span></span>
              <span className="logo-subtitle">Auto Inc.</span>
            </Link>
          </div>

          <div className="footer-links">
            <nav>
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <Link to="/contact">Contact</Link>
              <Link to="/payment">Payment</Link>
              <Link to="/shipping">Shipping</Link>
            </nav>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} EuroJDM Auto Inc.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
